import { IDiseaseHistoryData } from 'Components/sq-graphics';
import { getAtcCodesByPlatform } from 'Routes/Medication/Document/config';

const mgravisData = (
  fm: (id: string) => string,
  uiLang: Locale,
  medicationSettings: IOrganizationNeuroSettings['medicationSettings'] | undefined,
): IDiseaseHistoryData => {
  const clinicalMeters = fm('graph.clinicalMeters');
  const patientSelfReport = fm('graph.patientSelfReport');

  const atcCodes = getAtcCodesByPlatform(medicationSettings, 'mgravis');
  const atcOpts = medicationSettings?.mgravis?.localizations?.[uiLang as 'fi' | 'en'];

  return {
    graphData: {
      common: {
        mgc: {
          data: [],
          title: 'MGC',
          scale: {
            type: 'linear',
            linearScale: [0, 50],
          },
        },
        mgadlClinical: {
          data: [],
          title: fm('myService.mgravis.opts.mgadl'),
          scale: {
            type: 'linear',
            linearScale: [0, 24],
          },
        },
      },
      selfReporting: {
        mgadlMy: {
          data: [],
          title: fm('myService.mgravis.opts.mgadl'),
          scale: {
            type: 'linear',
            linearScale: [0, 24],
          },
        },
        fss: {
          data: [],
          title: fm('myService.mgravis.opts.fss'),
          scale: {
            type: 'linear',
            linearScale: [0, 7],
          },
        },
        eq5d: {
          data: [],
          title: fm('myService.mgravis.opts.eq5d'),
          scale: {
            type: 'hybridCL',
            linearScale: [0, 1],
            customScale: ['< 0'],
          },
        },
        mgQol15r: {
          data: [],
          title: fm('graph.selfReport.mgQol15r.title'),
          scale: {
            type: 'linear',
            linearScale: [0, 30],
          },
        },
      },
    },
    graphDataGroups: {
      common: {
        groupHeader: clinicalMeters,
        open: true,
      },
      selfReporting: {
        open: true,
        groupHeader: patientSelfReport,
        theme: 'myms',
      },
    },
    addonData: {
      mgfa: {
        id: 'mgfa',
        type: 'single',
        name: fm('diagnosis.mgravis.mgfa.title'),
        addons: [],
      },
      passQuestion: {
        id: 'passQuestion',
        type: 'single',
        name: fm('myService.mgravis.opts.passQuestion'),
        addons: [],
      },
      earlySymptoms: {
        id: 'earlySymptoms',
        type: 'single',
        name: fm('diagnosis.mgravis.symptoms.title'),
        addons: [],
      },
      diagnosis: {
        id: 'diagnosis',
        type: 'single',
        name: fm('diagnosis.title'),
        addons: [],
      },
      hospitalizations: {
        id: 'hospitalization',
        type: 'expansionPanel',
        name: fm('comorbidity.mgravis.title'),
        addons: [],
      },
      medications: {
        id: 'medications',
        type: 'expansionPanel',
        name: fm('graph.medications'),
        expansionPanelTitleDescription: [
          {
            title: fm('graph.atc-codes'),
            style: { fontWeight: 600 },
          },
        ].concat(
          Object.keys(atcOpts ?? {})
            .filter(code => atcCodes.includes(code))
            .map(code => {
              return { title: `${code} - ${atcOpts?.[code]}` };
            }) as [],
        ),
        addons: [],
        expansionPanelShowAlways: true,
      },
      endedMedications: {
        id: 'endedMedications',
        type: 'expansionPanel',
        name: fm('graph.endedMedications'),
        addons: [],
      },
      procedures: {
        id: 'procedures',
        type: 'expansionPanel',
        name: fm('procedure.title'),
        addons: [],
      },
      pregnancies: {
        id: 'pregnancies',
        type: 'single',
        name: fm('graph.pregnancies'),
        addons: [],
      },
      imaging: {
        id: 'imaging',
        type: 'single',
        name: fm('imaging.title'),
        addons: [],
      },
      cnpExaminations: {
        id: 'cnpExaminations',
        type: 'expansionPanel',
        name: fm('clpAndCnpTests.mgravis.title'),
        addons: [],
      },
      diagnosticTests: {
        id: 'diagnosticTests',
        type: 'expansionPanel',
        name: fm('diagnosticTests.title'),
        addons: [],
      },
    },
  };
};

export default mgravisData;
